import { Component } from '@verndale/core';

class Module extends Component {
  setupDefaults() {
    this.dom = {
      $searchInput: this.el.querySelector('.search-input'),
      $searchMenuButton: this.el.querySelector('.header__menu-search-button'),
      $clearBtn: this.el.querySelector('.search-form__clear'),
      $el: this.el,
      $menuItem: this.el.querySelectorAll('.header__megamenu-wrapper-item'),
      $mobileToggleMenuButton: this.el.querySelector('.header__mobile-menu-toggle-button'),
      $header: this.el.querySelector('.header'),
      $body: document.querySelector('body'),
      $primaryNav: this.el.querySelector('.header__primary-nav'),
      $headerWrapper: this.el.querySelector('.header__wrapper'),
    };

    this.el.dispatchEvent(new CustomEvent('scroll'));
    this.saveUtmParamsInCookies();
  }

  addListeners() {
    this.dom.$menuItem.forEach($menuItem => {
      $menuItem.addEventListener('click', this.toggleMegaMenu.bind(this));
    });
    this.dom.$mobileToggleMenuButton.addEventListener('click', this.toggleMobileMenu.bind(this));
    this.dom.$searchMenuButton.addEventListener('click', this.handleMobileSearch.bind(this));
    document.addEventListener('click', this.closeMegaMenus.bind(this));
    document.addEventListener('keyup', this.checkIfEscPress.bind(this));
    window.addEventListener('resize', this.handleResize.bind(this));
    window.addEventListener('scroll', this.handleDocumentScroll.bind(this));
    this.dom.$searchInput.addEventListener('keyup', this.handleKeyPress.bind(this));
    this.dom.$clearBtn.addEventListener('click', this.handleClickClear.bind(this));
  }

  handleKeyPress(e) {
    if (e.currentTarget.value !== '') {
      this.dom.$clearBtn.classList.add('search-form__clear--active');
    } else {
      this.dom.$clearBtn.classList.remove('search-form__clear--active');
    }
    this.handleUpdateResult();
  }

  handleClickClear() {
    this.dom.$searchInput.value = '';
    this.dom.$searchInput.focus();
    this.dom.$clearBtn.classList.remove('search-form__clear--active');
  }

  handleUpdateResult() {
    // Update query result
  }

  toggleMegaMenu(e) {
    e.stopPropagation();
    const $item = e.currentTarget;
    const $clickedElement = e.target;
    const $openElements = document.querySelectorAll(
      '.header__primary-nav-item-toggle--open'
    );
    
    if (
      $clickedElement.classList.contains('header__mega-menu') ||
      $clickedElement.closest('.header__mega-menu')
    )
      return;
    if (
        $item.classList.contains('header__primary-nav-item-toggle--open')
    ) {
      this.closeMegaMenus();
    } else {
      $openElements.forEach($openElement => {
        if ($openElement !== this) {
          $openElement.classList.remove(
            'header__primary-nav-item-toggle--open'
          );
          $openElement
            .querySelector('.header__mega-menu')
            ?.setAttribute('aria-hidden', 'true');
        }
      });

      $item
        .querySelector('.header__mega-menu')
        ?.setAttribute(
          'aria-hidden',
          $item.classList.contains('header__primary-nav-item-toggle--open')
            ? 'true'
            : 'false'
        );
      $item.classList.toggle('header__primary-nav-item-toggle--open');
    }

    if($item.classList.contains('header__primary-nav-item-toggle--open')) {
        this.dom.$el.classList.add('header__wrapper-menu--open');
        this.dom.$primaryNav.classList.add('header__primary-nav--open');
    } else {
        this.dom.$el.classList.remove('header__wrapper-menu--open');
        this.dom.$primaryNav.classList.remove('header__primary-nav--open');
    }
  }

  toggleMobileMenu() {
    this.dom.$header.classList.toggle('mobile-menu-open');
    if(this.dom.$header.classList.contains('mobile-menu-open')) {
        this.dom.$el.classList.add('header__wrapper-menu--open');
    } else {
        this.dom.$el.classList.remove('header__wrapper-menu--open');
        this.dom.$primaryNav.classList.remove('header__primary-nav--open');
    }
  }

  handleMobileSearch() {
    // since the search button stays in the top menu on mobile views, we need a special
    // handler to close the mobile menu when the search menu is opened
    if(this.dom.$header.classList.contains('mobile-menu-open')) {
      this.toggleMobileMenu();
    }
  }

  closeMegaMenus(e) {
    const $openItem = this.el.querySelector(
      '.header__primary-nav-item-toggle--open'
    );
    $openItem?.classList.remove('header__primary-nav-item-toggle--open');
    $openItem?.querySelector('.header__mega-menu')?.setAttribute('aria-hidden', 'true');

    if(!e) {
      this.dom.$el.classList.remove('header__wrapper-menu--open');
      this.dom.$primaryNav.classList.remove('header__primary-nav--open');
      return;
    }
    this.dom.$el.classList.remove('header__wrapper-menu--open');
    this.dom.$primaryNav.classList.remove('header__primary-nav--open');
  }

  handleResize() {
    this.dom.$header.classList.remove('mobile-menu-open');
    this.closeMegaMenus();
  }

  checkIfEscPress(e) {
    if (e.key === 'Escape') {
      this.dom.$header.classList.remove('mobile-menu-open');
      this.closeMegaMenus();
    }
  }

  backToTopMenu() {
    this.dom.$primaryNav.classList.remove('header__primary-nav--open');
    this.closeMegaMenus();
  }

  saveUtmParamsInCookies() {
    this.createCookieFromParam('utm_campaign');
    this.createCookieFromParam('utm_source');
    this.createCookieFromParam('utm_medium');
    this.createCookieFromParam('utm_content');

    const lastPageUrl = document.referrer;
    document.cookie=`amw_lastpagevisited=${lastPageUrl};path=/`;
  }

  createCookieFromParam (cookieName){
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    // eslint-disable-next-line no-unused-expressions
    urlParams.get(cookieName)?document.cookie=`${cookieName}=${urlParams.get(cookieName)}`:null;
  }
}

export default Module;
